import { render, staticRenderFns } from "./ProjectStyles.vue?vue&type=template&id=08487d8e"
import script from "./ProjectStyles.vue?vue&type=script&lang=ts"
export * from "./ProjectStyles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports